module.exports = __webpack_public_path__ + "static/6h-happy-b6e223976bd3d9f1f8a782ac6f23b584.png";